import axios from 'axios';
import * as Sentry from '@sentry/vue';
import { ProblemDocument } from 'http-problem-details';
import { BUS_EVENTO } from '@/shared/bus-evento/bus-evento';

import { SERVER_API_URL } from '@/constants';

const TIMEOUT = 1000000;
const onRequestSuccess = config => {
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};
const setupAxiosInterceptors = onUnauthenticated => {
  const onResponseError = err => {
    if (err && (err.status || (err.response && err.response.status))) {
      const status = err.status || (err.response ? err.response.status : -1);
      if (status === 403 || status === 401) {
        onUnauthenticated();
      } else if (status === -1) {
        JSON.stringify(err);
      }
    } else {
      Sentry.captureMessage(`Excepción sin status ${JSON.stringify(err)}`);
    }

    return Promise.reject(err);
  };
  const onResponseErrorMessage = err => {
    if (err && (err.status || (err.response && err.response.status))) {
      const status = err.status || (err.response ? err.response.status : -1);
      if (err.response && status >= 400) {
        if (
          err.response.headers['content-type'] === 'application/problem+json' &&
          err.config.method !== 'get' &&
          err.config.url !== 'api/account'
        ) {
          const problem: ProblemDocument = err.response.data;
          const keyI18n: string = err.response.headers['x-formalizacionmsapp-error']
            ? err.response.headers['x-formalizacionmsapp-error']
            : '';
          BUS_EVENTO.$emit('problem-detected', problem, keyI18n, 60000);
        }

        if (status >= 500) {
          if (err.config && err.config.url && err.config.url.indexOf('api/notificaciones') !== -1) {
            Sentry.captureMessage(`Error al recuperar notificación ${JSON.stringify(err)}`);
          } else {
            Sentry.captureException(err);
          }
        }
      }
    } else {
      Sentry.captureMessage(`Response Error sin status ${JSON.stringify(err)}`);
    }

    return Promise.reject(err);
  };
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(res => res, onResponseError);
    axios.interceptors.response.use(undefined, onResponseErrorMessage);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
